


















































































































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Component, Watch } from "vue-property-decorator";
import { $api } from "@/services/ApiService";
import { Key, User } from "bancojs";
import { debounce } from "@/services/core/Utils";

@Component
export default class AdminKeysEdit extends Vue {
  async created() {
    if (this.$route.params.id) {
      try {
        const res = await $api.client.admin.keys
          .get(Number(this.$route.params.id))
          .toPromise();
        this._getUsers(res.user_id, "");
        this._getWrappingkeysById(res.wrapping_key_id || NaN);
        this.form.data = res;
      } catch (err) {
        console.log(err);
      } finally {
        this.form.loading = false;
      }
    } else {
      this.form.editing = false;
      this.form.loading = false;
    }
  }

  async saveKey() {
    if (this.form.editing) return;

    try {
      this.form.saving = true;
      await $api.client.admin.keys.create(this.form.data).toPromise();
      this.form.saving = false;
      this.$router.push("/admin/keys");
    } catch (err) {
      console.log(err);
      this.form.saving = false;
    }
  }

  async _getUsers(newVal: string, oldVal: string) {
    if (newVal == this.form.data.user_id || newVal == null || newVal.length < 2)
      return;
    this.form.loadingUsers = true;
    const users = await $api.client.admin.users
      .find({ id: newVal })
      .toPromise();
    this.form.loadingUsers = false;
    this.form.userList = users.content;
  }

  async _getWrappingkeysById(id: number) {
    if (id == null || isNaN(id))
      return;
    this.form.loadingWrappingKeys = true;
    const wrappingKeys = await $api.client.admin.keys
      .find({ id })
      .toPromise();
    this.form.loadingWrappingKeys = false;
    this.form.wrappingKeyList = wrappingKeys.content;
  }

  async _getWrappingkeys(newVal: string, oldVal: string) {
    if (newVal == null || newVal.length < 2)
      return;
    this.form.loadingWrappingKeys = true;
    const wrappingKeys = await $api.client.admin.keys
      .find({ alias: newVal, type: "WRAPPING" })
      .toPromise();
    this.form.loadingWrappingKeys = false;
    this.form.wrappingKeyList = wrappingKeys.content;
  }

  @Watch("form.searchUser")
  getUsers = debounce(this._getUsers, 300);

  @Watch("form.searchWrappingKey")
  getWrappingKeys = debounce(this._getWrappingkeys, 300);

  rules = {
    required: (val: any) => !!val || "Campo requerido.",
    requiredKey(type: any, wk_id: any) {
      if (type != "WRAPPED") return true;
      else return !!wk_id || 'Campo requerido.';
    },
    maxPin(type: any, val: any) {
      if (type != "WRAPPED") return true;
      else return val?.length <= 16 || "El campo es mayor a 16 caracteres."
    },
  };

  get keyTypes() {
    return [
      {
        text: "Persistente",
        value: "PERSISTENT",
      },
      {
        text: "Encapsulada (Wrapped)",
        value: "WRAPPED",
      },
      {
        text: "Encapsulamiento (Wrapping)",
        value: "WRAPPING",
      },
    ];
  }

  form: {
    data: Key;
    userList: User[];
    wrappingKeyList: Key[];
    searchUser: string;
    searchWrappingKey: string;
    saving: boolean;
    loading: boolean;
    loadingUsers: boolean;
    loadingWrappingKeys: boolean;
    editing: boolean;
    validForm: boolean;
  } = {
    data: {
      id: NaN,
      alias: "",
      type: "PERSISTENT",
      user_id: "",
      wrapping_key_id: NaN,
      pin: "",
    },
    userList: [],
    wrappingKeyList: [],
    searchUser: "",
    searchWrappingKey: "",
    saving: false,
    loading: true,
    loadingUsers: false,
    loadingWrappingKeys: false,
    editing: true,
    validForm: false,
  };
}
